import { useCallback, useRef } from 'react';


export default function useGetPowerController(sendEvent) {
    const getPowerCallbacks = useRef({});
    const registerNotification = useCallback((callbackId, callback) => {
        getPowerCallbacks.current[callbackId] = callback;
    }, []);
    const unregisterNotification = useCallback((callbackId) => {
        if (callbackId in getPowerCallbacks.current)
            delete getPowerCallbacks.current[callbackId];
    }, []);

    const onGetPower = useCallback((message) => {
        const id = message.msg["id"];
        const data = message.msg["data"];

        // if (getPowerCallbacks.current.hasOwnProperty(id)) {
        if (Object.prototype.hasOwnProperty.call(getPowerCallbacks.current, id)) {
            const callback = getPowerCallbacks.current[id];
            callback(data);
        }

        unregisterNotification(id);
    }, [unregisterNotification, getPowerCallbacks]);

    const requestGetPower = useCallback((id, callback, mac, from, to, step) => {
        registerNotification(id, callback);
        sendEvent('get_power', {
            "id": id,
            "mac": mac,
            "from": from,
            "to": to,
            "step": step,
        });
        // for test
        // onGetPower({ msg: { id, data: [1, 2, 3, 4, 5, 6, -1, -1, 1, 1, 2, 3, 4] } })
    }, [registerNotification, sendEvent]);

    return [onGetPower, requestGetPower];
}